import { Component } from '@angular/core';

@Component({
	selector: 'app-select',
	templateUrl: './select.component.html',
	styleUrls: ['./select.component.css'],
})
export class SelectComponent {
	placeholder = '';
	selectValue = '';
	selectSearch = '';

	constructor() {}
}
